<template>
  <div>
    <vxe-grid
      ref="fileTable"
      border
      auto-resize
      highlight-hover-row
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :data="tableData"
      :columns="tableColumns"
      :height="600"
      size="mini"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="d-flex mt-2">
            <div class="side-frame-danger"></div>
            <div>
              <span style="font-size: 14px; color: #606266">
                {{ $l('table_doc_header_title') || '关联附件' }}
              </span>
              <el-divider direction="vertical"></el-divider>
              <b-button
                size="sm"
                class="ml-2"
                variant="outline-success"
                @click="uploadDocVisible = true"
              >
                {{ $l('btn_uploadDoc') || '上传文档' }}
              </b-button>
            </div>
          </div>
        </slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createTime }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyTime }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_preview') || '预览'"
            placement="top"
          >
            <i class="el-icon-view tool-btn" @click="preview(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_downloada') || '下载'"
            placement="top"
          >
            <i class="el-icon-download tool-btn" @click="downloadFile(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>

    <UploadDoc
      :title="$l('dialog_title_uploadDoc') || '上传订单附件'"
      :visible.sync="uploadDocVisible"
      @upload="onUpload"
    />
  </div>
</template>
<script>
import UploadDoc from '../upload-doc'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './file-table-columns.js'
export default {
  props: { orderCode: { type: String, default: '' } },
  components: { UploadDoc },
  mixins: [EditLoading],
  data() {
    return {
      tableColumns: tableColumns(this),
      tableData: [],
      uploadDocVisible: false,
    }
  },
  methods: {
    downloadFile({ fileCode }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode)
    },
    preview({ fileCode }) {
      this.$api.SYS_FILEDOWNLOAD(fileCode, { preview: true, isAutoDown: true })
    },
    async del({ orderFileCode }) {
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomOrderDelFileApi({ orderFileCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, msg } = res || {}
      if (200 !== status) {
        this.$message.error(msg)
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      await this.getData()
    },
    async getData() {
      const res = await this.$api
        .ecomOrderFileListApi({
          orderCode: this.orderCode,
        })
        .catch(() => null)
      this.tableData = res?.body?.data || []
    },
    async onUpload(data) {
      if (!data) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .ecomOrderUploadFileApi({
          orderCode: this.orderCode,
          files: data,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res || {}
      if (200 !== status) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success') || '上传成功',
        type: 'success',
      })
      await this.getData()
    },
  },
  async mounted() {
    await this.getData()
  },
}
</script>
<style lang="scss" scoped>
.side-frame-danger {
  padding: 1px 5px;
  border-left: 3px solid $color-danger;
  height: 20px;
  margin-top: 3px;
}
</style>
